// import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import AddLocationIcon from '@mui/icons-material/AddLocation';
// import { formatSegment, PriceFormatter } from '../../../common/common';
// import { useNavigate } from 'react-router-dom';
// import '../../../styles/PropertyCard.css';
// const emptyPropertyImage = "/media/images/gridimgae.jpeg";

// const PropertyCard = ({ property, handleEnquiry }) => {
//     const navigate = useNavigate();

//     const formatPriceINR = (price) => {
//         return new Intl.NumberFormat('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             maximumFractionDigits: 0 // No decimal points
//         }).format(price);
//     };

//     function handleToNavigate() {
//         navigate(`/property/${formatSegment(property.listingType)}/${formatSegment(property.propertyName)}/${formatSegment(property.buildingType + "-" + property.propertyType + "-in-" + property.locality + "-" + property.city)}/${property.propertyId}`)
//     }
//     return (
//         <div className="property-card">
//             <div className="image-container">
//                 <img src={property.imageData?.find(item => item.imageType === "featured")?.imagePath || emptyPropertyImage} alt={property.title} className="property-image" />
//                 <div className="image-overlay" />
//                 <div className="listing-type">{property.listingType === 'rent' ? 'For Rent' : 'For Sale'}</div>
//             </div>

//             <div className="content-container">
//                 <h3 className="property-title">{property.title}</h3>

//                 <div className="location-container">
//                     <AddLocationIcon className="icon" />
//                     <span className="location-text">
//                         {property.city}, {property.state}
//                     </span>
//                 </div>

//                 <div className="price-container">
//                     <span className="price-text">
//                         {formatPriceINR(property.rent)}
//                         {property.listingType === 'rent' && '/month'}
//                     </span>
//                 </div>

//                 <div className="amenities-container">
//                     {property.numOfBedrooms && (
//                         <span className="amenity-tag">
//                             {property.numOfBedrooms && (property.numOfBedrooms === "Studio" || property.numOfBedrooms === "1 RK" ? property.numOfBedrooms : property.numOfBedrooms + " BHK")}
//                         </span>
//                     )}
//                     {property.superBuiltupArea && (
//                         <span className="amenity-tag">
//                             {property.superBuiltupArea && property.superBuiltupArea + property.areaUnit}
//                         </span>
//                     )}
//                     {property.furnishingType && (
//                         <span className="amenity-tag">
//                             {property.furnishingType}
//                         </span>
//                     )}
//                     {property.positionStatus && (
//                         <span className="amenity-tag">
//                             {property.positionStatus && property.positionStatus}
//                         </span>
//                     )}
//                 </div>

//                 <div className="buttons-container">
//                     <button
//                         className="btn btn-primary"
//                         onClick={handleEnquiry}
//                     >
//                         <span className="icon-container">
//                             <ChatBubbleIcon className="icon" />
//                         </span>
//                         Enquiry Now
//                     </button>
//                     <button
//                         className="btn btn-outline"
//                         onClick={() => handleToNavigate(property)}
//                     >
//                         <span>More Details</span>
//                         <span className="icon-container">
//                             <ArrowForwardIcon className="icon" />
//                         </span>
//                     </button>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default PropertyCard











import { useState } from 'react';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddLocationIcon from '@mui/icons-material/LocationOn';
import HotelIcon from '@mui/icons-material/Hotel';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import StarIcon from '@mui/icons-material/Star';
import { formatSegment } from '../../../common/common';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

const emptyPropertyImage = "/media/images/gridimgae.jpeg";

const PropertyCard = ({ property, handleEnquiry }) => {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);

    const formatPriceINR = (price) => {
        if (!price) return 'Price on request';
        try {
            const numPrice = typeof price === 'string' ?
                parseInt(price.replace(/[^0-9]/g, '')) :
                price;

            if (numPrice >= 10000000) {
                return `₹${(numPrice / 10000000).toFixed(2)} Cr`;
            } else if (numPrice >= 100000) {
                return `₹${(numPrice / 100000).toFixed(1)} L`;
            } else {
                return `₹${numPrice.toLocaleString('en-IN')}`;
            }
        } catch (error) {
            return price || 'Price on request';
        }
    };

    function handleToNavigate() {
        if (property.propertyId && property.propertyName) {
            const listingType = property.listingType || 'sale';
            const propertyName = property.propertyName || property.title || 'property';
            const location = (property.buildingType || property.propertyType) + "-in-" + (property.locality || property.city || 'location');
            navigate(`/property/${formatSegment(listingType)}/${formatSegment(propertyName)}/${formatSegment(location)}/${property.propertyId}`);
        }
    }

    return (
        <Box
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            sx={{
                width: '100%',
                backgroundColor: 'white',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                minHeight: { xs: '400px', sm: '420px', md: '440px' },
                border: '1px solid #f3f4f6',
                '&:hover': {
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                    transform: 'translateY(-4px)',
                    borderColor: '#dc2626',
                }
            }}
        >
            {/* Image Section */}
            <Box
                sx={{
                    position: 'relative',
                    height: { xs: '160px', sm: '180px', md: '200px' },
                    width: '100%',
                    overflow: 'hidden',
                }}
            >
                <Box
                    component="img"
                    src={property.imageUrl || property.imageData?.find(item => item.imageType === "featured")?.imagePath || emptyPropertyImage}
                    alt={property.propertyName || property.title || "Property"}
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.4s ease',
                        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                    }}
                />

                {/* Property Badge */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '12px',
                        left: '12px',
                        background: 'linear-gradient(135deg, #dc2626, #ef4444)',
                        color: 'white',
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: { xs: '10px', sm: '11px' },
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        letterSpacing: '0.3px',
                        zIndex: 2,
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    }}
                >
                    <StarIcon sx={{ fontSize: { xs: '10px', sm: '12px' } }} />
                    <span>Premium</span>
                </Box>

                {/* Property Type Badge */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        color: '#374151',
                        padding: '4px 10px',
                        borderRadius: '4px',
                        fontSize: { xs: '10px', sm: '11px' },
                        fontWeight: 600,
                        backdropFilter: 'blur(4px)',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    {property.propertyType || 'Property'}
                </Box>

                {/* Listing Type Badge */}
                {property.listingType && (
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: '12px',
                            left: '12px',
                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                            color: '#dc2626',
                            padding: '4px 10px',
                            borderRadius: '4px',
                            fontSize: { xs: '10px', sm: '11px' },
                            fontWeight: 600,
                            backdropFilter: 'blur(4px)',
                            textTransform: 'capitalize',
                        }}
                    >
                        {property.listingType === 'rent' ? 'For Rent' : 'For Sale'}
                    </Box>
                )}
            </Box>

            {/* Content Section */}
            <Box
                sx={{
                    padding: { xs: '16px', sm: '18px', md: '20px' },
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                }}
            >
                {/* Title */}
                <Box
                    component="h3"
                    sx={{
                        fontSize: { xs: '15px', sm: '16px', md: '17px' },
                        fontWeight: 600,
                        color: '#111827',
                        margin: '0 0 8px 0',
                        lineHeight: 1.4,
                        height: { xs: '42px', sm: '44px' },
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                    title={property.propertyName || property.title}
                >
                    {property.propertyName || property.title || "Premium Property"}
                </Box>

                {/* Location */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        marginBottom: '12px',
                        height: '20px',
                    }}
                >
                    <AddLocationIcon sx={{
                        fontSize: { xs: '14px', sm: '15px' },
                        color: '#6b7280',
                        flexShrink: 0
                    }} />
                    <Box
                        component="span"
                        sx={{
                            fontSize: { xs: '12px', sm: '13px' },
                            color: '#6b7280',
                            fontWeight: 500,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {property.location || property.locality || property.city}
                    </Box>
                </Box>

                {/* Price */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        marginBottom: '16px',
                        height: '24px',
                    }}
                >
                    <CurrencyRupeeIcon sx={{
                        fontSize: { xs: '15px', sm: '16px' },
                        color: '#dc2626',
                        flexShrink: 0
                    }} />
                    <Box
                        component="span"
                        sx={{
                            fontSize: { xs: '16px', sm: '18px', md: '20px' },
                            fontWeight: 700,
                            color: '#dc2626',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {formatPriceINR(property.price || property.rent)}
                        {(property.listingType === 'rent') && (
                            <Box
                                component="span"
                                sx={{
                                    fontSize: { xs: '12px', sm: '13px' },
                                    color: '#6b7280',
                                    fontWeight: 500,
                                    marginLeft: '2px',
                                }}
                            >
                                /month
                            </Box>
                        )}
                    </Box>
                </Box>

                {/* Features - Grid Layout */}
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: { xs: '8px', sm: '12px' },
                        marginBottom: '16px',
                        paddingBottom: '16px',
                        borderBottom: '1px solid #f3f4f6',
                        alignItems: 'center',
                        justifyItems: 'center',
                    }}
                >
                    {/* Bedrooms */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '4px',
                            width: '100%',
                        }}
                    >
                        <HotelIcon sx={{
                            fontSize: { xs: '16px', sm: '18px' },
                            color: '#dc2626'
                        }} />
                        <Box
                            component="span"
                            sx={{
                                fontSize: { xs: '11px', sm: '12px' },
                                color: '#374151',
                                fontWeight: 500,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {property.numOfBedrooms || property.bedrooms || 0} {property.numOfBedrooms === 1 || property.bedrooms === 1 ? 'Bed' : 'Beds'}
                        </Box>
                    </Box>

                    {/* Bathrooms */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '4px',
                            width: '100%',
                        }}
                    >
                        <BathtubIcon sx={{
                            fontSize: { xs: '16px', sm: '18px' },
                            color: '#dc2626'
                        }} />
                        <Box
                            component="span"
                            sx={{
                                fontSize: { xs: '11px', sm: '12px' },
                                color: '#374151',
                                fontWeight: 500,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {property.numOfBathrooms || property.bathrooms || 0} {property.numOfBathrooms === 1 || property.bathrooms === 1 ? 'Bath' : 'Baths'}
                        </Box>
                    </Box>

                    {/* Area */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '4px',
                            width: '100%',
                        }}
                    >
                        <SquareFootIcon sx={{
                            fontSize: { xs: '16px', sm: '18px' },
                            color: '#dc2626'
                        }} />
                        <Box
                            component="span"
                            sx={{
                                fontSize: { xs: '11px', sm: '12px' },
                                color: '#374151',
                                fontWeight: 500,
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {property.area || 'N/A'}
                        </Box>
                    </Box>
                </Box>

                {/* Additional Features */}
                {(property.furnishingType || property.positionStatus) && (
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '6px',
                            marginBottom: '16px',
                        }}
                    >
                        {property.furnishingType && (
                            <Box
                                sx={{
                                    padding: '4px 8px',
                                    backgroundColor: 'rgba(220, 38, 38, 0.08)',
                                    color: '#dc2626',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    fontWeight: 500,
                                }}
                            >
                                {property.furnishingType}
                            </Box>
                        )}
                        {property.positionStatus && (
                            <Box
                                sx={{
                                    padding: '4px 8px',
                                    backgroundColor: 'rgba(220, 38, 38, 0.08)',
                                    color: '#dc2626',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    fontWeight: 500,
                                }}
                            >
                                {property.positionStatus}
                            </Box>
                        )}
                    </Box>
                )}

                {/* Action Buttons */}
                <Box
                    sx={{
                        display: 'flex',
                        gap: '8px',
                        marginTop: 'auto',
                        height: { xs: '36px', sm: '40px' },
                    }}
                >
                    {/* Enquiry Button */}
                    <Box
                        component="button"
                        onClick={handleEnquiry}
                        sx={{
                            flex: 1,
                            height: '100%',
                            borderRadius: '6px',
                            fontSize: { xs: '12px', sm: '13px' },
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            border: 'none',
                            backgroundColor: '#dc2626',
                            color: 'white',
                            padding: '0 8px',
                            minWidth: 0,
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                backgroundColor: '#b91c1c',
                                boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
                                transform: 'translateY(-1px)',
                            },
                            '&:active': {
                                transform: 'translateY(0)',
                            }
                        }}
                    >
                        <ChatBubbleIcon sx={{ fontSize: { xs: '14px', sm: '16px' } }} />
                        <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                            Enquiry Now
                        </Box>
                    </Box>

                    {/* Details Button */}
                    <Box
                        component="button"
                        onClick={handleToNavigate}
                        sx={{
                            flex: 1,
                            height: '100%',
                            borderRadius: '6px',
                            fontSize: { xs: '12px', sm: '13px' },
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            border: '1px solid #dc2626',
                            backgroundColor: 'white',
                            color: '#dc2626',
                            padding: '0 8px',
                            minWidth: 0,
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                backgroundColor: '#fef2f2',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 12px rgba(220, 38, 38, 0.1)',
                            },
                            '&:active': {
                                transform: 'translateY(0)',
                            }
                        }}
                    >
                        <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                            View Details
                        </Box>
                        <ArrowForwardIcon sx={{ fontSize: { xs: '14px', sm: '16px' } }} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default PropertyCard;